<template>
<div class="text-xs-center">
  <v-menu offset-y>
    <template v-slot:activator="{ on }">
      <v-btn v-on="on" color="teal darken-4" fab small dark>
        <v-icon class="schema-edit-icon" dark>settings</v-icon>
      </v-btn>
    </template>

    <v-list>
      <v-list-tile>
        <router-link :to="{ name:'schema-action', params: { schemaId: schema.id }}" class="dropdown-item">
          <v-list-tile-title>Akcje</v-list-tile-title>
        </router-link>
      </v-list-tile>
      <v-list-tile>
        <router-link :to="{ name:'schema-presentation', params: { schemaId: schema.id }}" class="dropdown-item">
          <v-list-tile-title>{{$t('schema.presentation')}}</v-list-tile-title>
        </router-link>
      </v-list-tile>
      <v-list-tile>
        <router-link :to="{ name:'schema-translation', params: { schemaId: schema.id }}" class="dropdown-item">
          <v-list-tile-title>{{$t('schema.translation')}}</v-list-tile-title>
        </router-link>
      </v-list-tile>
      <v-list-tile>
        <router-link :to="{ name:'calendar-schema', params: { schemaId: schema.id }}" class="dropdown-item">
          <v-list-tile-title>Kalendarz</v-list-tile-title>
        </router-link>
      </v-list-tile>
      <v-list-tile>
        <router-link :to="{ name:'schema-related-map', params: { schemaId: schema.id }}" class="dropdown-item">
          <v-list-tile-title>Mapowanie do bazy relacyjnej</v-list-tile-title>
        </router-link>
      </v-list-tile>
      <v-list-tile v-if="false && schema.type == schemaType.DOCUMENT">
        <router-link  :to="{ name:'document-map', params: { schemaId: schema.id }}" class="dropdown-item">
          <v-list-tile-title>{{$t('Mapowanie')}}</v-list-tile-title>
        </router-link>
      </v-list-tile>
      <v-list-tile v-if="false && schema.type == schemaType.DOCUMENT">
        <router-link  :to="{ name:'document-template', params: { schemaId: schema.id }}" class="dropdown-item">
          <v-list-tile-title>{{$t('Szablon  OCR')}}</v-list-tile-title>
        </router-link>
      </v-list-tile>
    </v-list>

  </v-menu>
</div>
</template>
<script>
import schemaType from "@/enums/schemaType";
export default {
  props: ['schema'],
  data(){
    return{
      schemaType
    }
  }
}
</script>
<style>
.dropdown-item {
  text-decoration: none !important;
  color: black !important;
}
</style>
